import Keycloak from 'keycloak-js'
import { env } from '../env.js'

let keycloak = null

if (typeof window !== 'undefined') {

    keycloak = new Keycloak({
        realm: env.REALM,
        url: env.AUTH_SERVER_ROOT,
        sslRequired: 'external',
        resource: env.RESOURCE_REALM,
        clientId: env.RESOURCE_REALM,
        publicClient: true,
        verifyTokenAudience: true,
        useResourceRoleMappings: true,
        confidentialPort: 0,
    })
}

export default keycloak
